import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLanguage } from "../i18n";

const HERO_PHOTO = "/assets/hero-alsera.jpg";

export const HeroMockup = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yMain = useTransform(scrollYProgress, [0, 1], [0, -70]);
  const yShape = useTransform(scrollYProgress, [0, 1], [0, -40]);

  return (
    <div ref={ref} className="relative" data-testid="hero-visual">
      <motion.div style={{ y: yShape }} className="absolute -top-10 right-6 h-24 w-24 animate-float-slow rounded-3xl border border-salvia/50 bg-acqua/70 backdrop-blur" aria-hidden="true" />
      <motion.div style={{ y: yShape }} className="absolute -left-8 bottom-10 h-16 w-16 rounded-full bg-salvia/40" aria-hidden="true" />

      <motion.div
        style={{ y: yMain }}
        initial={{ opacity: 0, y: 40, rotate: 2 }}
        animate={{ opacity: 1, y: 0, rotate: 0 }}
        transition={{ duration: 1, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
        className="relative ml-auto w-[92%] overflow-hidden rounded-2xl border border-salvia/40 bg-white shadow-2xl shadow-petrolio/15"
      >
        <div className="flex items-center gap-1.5 border-b border-salvia/30 bg-white px-4 py-2.5">
          <span className="h-2.5 w-2.5 rounded-full bg-salvia" />
          <span className="h-2.5 w-2.5 rounded-full bg-acqua" />
          <span className="h-2.5 w-2.5 rounded-full bg-petrolio/60" />
          <span className="ml-3 h-5 flex-1 rounded-full bg-acqua/60" aria-hidden="true" />
        </div>
        <img
          src={HERO_PHOTO}
          alt={t("Il sito vetrina Alsera su laptop e smartphone")}
          className="aspect-[3/2] w-full object-cover"
          decoding="async"
          fetchPriority="high"
          data-testid="hero-photo"
        />
      </motion.div>
    </div>
  );
};
